const accessPay = {
  path: 'accessPay',
  component: resolve => require(['@/pages/admin/reviewed/wechat/accessPay'], resolve),
  meta: {isAccessPay: true},
}

export default accessPay
